import React from "react";
import { Routes, Route } from "react-router-dom";
import AppLayout from "../src/layout/AppLayout";
import Home from "./pages/Home";
import Explore from "./pages/Explore";
import Pricing from "./pages/Pricing";
import ExploreDetails from "./pages/ExploreDetails";
import Profile from "./pages/Profile";
import LoginPage from "./pages/auth/login";
import RegisterPage from "./pages/auth/register";
import ForgotPasswordPage from "./pages/auth/ForgotPasswordPage";
import Help from "./pages/Help";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Terms from "./pages/Terms";
import Notifications from "./pages/Notifications";
import ComingSoon from "./pages/ComingSoon";
import CommunityListing from "./pages/community/CommunityListing";
import CommunityDetails from "./pages/community/CommunityDetails";
import AddConversation from "./pages/community/AddConversation";

const App = () => {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route element={<AppLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/explore" element={<Explore />} />
        <Route path="/explore/:id" element={<ExploreDetails />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/community" element={<CommunityListing />} />
        <Route path="/community/:id" element={<CommunityDetails />} />
        <Route path="/add-conversation" element={<AddConversation />} />
        <Route path="/help" element={<Help />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/profile/:id" element={<Profile />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/notifications" element={<Notifications />} />
        <Route path="/coming-soon" element={<ComingSoon />} />
      </Route>
    </Routes>
  );
};

export default App;
